module.exports = __webpack_public_path__ + "static/media/close.a8c6011c.svg";